/* Native details work without JavaScript. Open the selected row in the theme editor. */
if (!customElements.get('mommily-product-tabs')) {
  customElements.define('mommily-product-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.onBlockSelect) return;
      this.onBlockSelect = (event) => {
        const row = event.target.closest('[data-mt-row]');
        if (row && this.contains(row)) row.open = true;
      };
      this.addEventListener('shopify:block:select', this.onBlockSelect);
    }
    disconnectedCallback() {
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.onBlockSelect = null;
    }
  });
}
